import * as React from 'react'

import { IMapSettings } from '~/client/src/shared/components/MapBoxViewer/mapSettings'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/client/src/shared/components/shadcn-ui/popover'

import MapSettingsPanel from './MapSettingsPanel'

interface IMapSettingsPopoverProps {
  trigger: React.ReactElement
  settings: IMapSettings
}

const MapSettingsPopover: React.FC<IMapSettingsPopoverProps> = ({
  trigger,
  settings,
}) => {
  const [open, setOpen] = React.useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger render={trigger} />
      <PopoverContent
        side="top"
        align="start"
        sideOffset={8}
        className="tw:w-auto tw:outline-none"
        onMouseDown={(e: React.MouseEvent) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <MapSettingsPanel settings={settings} onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}

export default MapSettingsPopover
